import Vue from "vue";
import { Component } from "vue-property-decorator";
import SupervisorPlaceAttachmentRestModel from "../../../models/rest/supervisor/supervisorPlaceAttachmentRestModel";
import VForm from "../../../models/v-form";

@Component
export default class PlaceAttachmentDialog extends Vue {
    isPod = false;

    validation = {
        files: [
            (files: any) => {
                return !files || !files.some((file: any) => file.size > 20_971_520) || 'Attachment size should be less than 20 MB!'
            }
        ],
    };

    get placeAttachmentDialogCurrentPlaceId(): number {
        return this.$store.direct.state.supervisor.placeAttachmentDialogCurrentPlaceId;
    }

    get placeAttachmentDialogAttachments(): SupervisorPlaceAttachmentRestModel[] {
        return this.$store.direct.state.supervisor.placeAttachmentDialogAttachments;
    }

    set placeAttachmentDialogAttachments(value: SupervisorPlaceAttachmentRestModel[]) {
        this.$store.direct.commit.supervisor.setPlaceAttachmentDialogAttachments(value);
    }

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    get showDialog(): boolean {
        return this.$store.direct.state.supervisor.showPlaceAttachmentDialog;
    }

    updated() {
        this.$nextTick(function () {
            if (this.$refs.form) (this.$refs.form as VForm).resetValidation();
        });
    }

    async saveClick(): Promise<void> {
        if ((this.$refs.form as VForm).validate()) {
            await this.$store.direct.dispatch.supervisor.savePlaceAttachments({ files: this.placeAttachmentDialogAttachments, isPod: this.isPod, placeId: this.placeAttachmentDialogCurrentPlaceId });
            await this.$store.direct.dispatch.supervisor.isConfirmedPlaceAttachmentDialog();
            this.isPod = false;
        }
    }

    closeClick(): void {
        this.$store.direct.dispatch.supervisor.isNotConfirmedPlaceAttachmentDialog();
        this.isPod = false;
    }
}
